export default __webpack_public_path__ + "static/media/searchIcon.7124fba5.svg";